export const InstallerEquipmentReportAsync = () => import("./InstallerEquipmentReport.vue");
